import { createRouter, createWebHistory } from 'vue-router'
import CaptchaHistoria from '../views/CaptchaHistoria.vue'
import HistoriaView from '../views/HistoriaView.vue'

const routes = [
  {
    path: '/',
    redirect: '/principal'  // Redirige la ruta raíz a /principal
  },
  {
    path: '/principal',
    name: 'buscaOperador',
    component: CaptchaHistoria
  },
  {
    path: '/principal/historia',
    name: 'historiaOperador',
    component: HistoriaView,
    props: route => ({ id: route.query.id })  // Pasar el query parameter 'id' como prop
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
